export default __webpack_public_path__ + "static/media/press_6.1335380b.webp";